import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import BranchRenderer from 'timeSheet/components/CellRenderers/BranchRenderer';

const useBranchColumn = ({ mappedBranches }) => {
  const { t } = useContext(ConfigContext);

  const valueGetter = useCallback((params) => mappedBranches?.[params.data?.branchId]?.name || '', [mappedBranches]);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return BranchRenderer({
        rowData: params.data,
        columnData: { mappedBranches }
      });
    },
    [mappedBranches]
  );

  return useMemo(
    () => ({
      field: 'branchId',
      headerName: t('branch'),
      cellClass: 'justify-start',
      width: 200,
      sortable: true,
      valueGetter,
      cellRenderer
    }),
    [t, valueGetter, cellRenderer]
  );
};

export default useBranchColumn;
